import script from "./FeedbackComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeedbackComponent.vue?vue&type=script&lang=ts&setup=true"

import "./FeedbackComponent.vue?vue&type=style&index=0&id=b8feb2a0&lang=scss"
import "./FeedbackComponent.vue?vue&type=style&index=1&id=b8feb2a0&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/builds/zWSsVt89/0/mentor-canada/moodle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8feb2a0"]])

export default __exports__